import React from "react";
import { Route } from "react-router-dom";
import Earnings from "./Earnings";
import Details from "./details";
const Router = ({ match }) => {
  return (
    <React.Fragment>
      <Route path={`${match.path}/earnings`} component={Earnings}></Route>
      <Route path={`${match.path}/detail/:id`} component={Details}></Route>
    </React.Fragment>
  );
};
export default Router;
